<template>
  <div class="view1">
    <div class="allHeader downicon">
      <van-nav-bar
        title="首页"
      />
    </div>
    <div style="height: 45px"></div>
    <van-swipe :autoplay="5000">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image" />
      </van-swipe-item>
    </van-swipe>
    <van-grid :column-num="3" class="grids">
      <div class="dots" v-if="mnun!=0">{{mnun}}</div>
      <van-grid-item icon="comment-o" text="通知消息" @click="go('message','add','通知消息')"/>
      <van-grid-item icon="setting-o" text="维护上报" @click="go('thingswh','add','维护上报')"/>
      <van-grid-item icon="certificate" text="维护记录" @click="go('yhxfwh','add','维护记录')"/>
      <van-grid-item icon="photo-o" text="保养上报" @click="go('thingsby','add','保养上报')"/>
      <van-grid-item icon="certificate" text="保养记录" @click="go('yhxfby','add','保养记录')"/>
      <van-grid-item icon="home-o" text="点检上报" @click="go('thingsdj','add','点检上报')"/>
      <van-grid-item icon="certificate" text="点检记录" @click="go('yhxfdj','add','点检记录')"/>
      <van-grid-item icon="location-o" text="巡检上报" @click="go('things','add','巡检上报')"/>
      <van-grid-item icon="certificate" text="巡检记录" @click="go('yhxf','add','巡检记录')"/>
      <van-grid-item icon="bulb-o" text="报警确认" @click="go('thingsgzqr','add','报警确认')"/>
      <van-grid-item icon="certificate" text="报警确认记录" @click="go('yhxfgzqr','add','报警确认记录')"/>
      <van-grid-item icon="close" text="故障消除" @click="go('thingsgzxc','add','故障消除')"/>
      <van-grid-item icon="certificate" text="故障消除记录" @click="go('yhxfgzxc','add','故障消除记录')"/>
      <van-grid-item icon="bar-chart-o" text="实时分析" @click="go('sbfx','add','设备列表')"/>
      <!-- <van-grid-item icon="edit" text="巡检整改" @click="go('yhzg','add','巡检整改')"/>
      <van-grid-item icon="underway-o" text="延期申请" @click="go('things','add','延期申请')"/> 
      <van-grid-item icon="todo-list-o" text="延期审批" @click="go('yqsp','add','延期审批')"/>
      <van-grid-item icon="completed" text="整改验收" @click="go('zgys','add','整改验收')"/>
      <van-grid-item icon="certificate" text="归档" @click="go('ygd','add','已归档')"/>-->
    </van-grid>
  </div>
</template>
<script>
import _URL from "../../lib/url";
import { Toast, Dialog } from "vant";
import { getAction, postAction } from "@/api/manage";
export default {
  name: "sign",
  components: {},
  data: function () {
    return {
      images: ["image/1.jpg", "image/2.jpg"],
      mnun:'0'
    };
  },
  mounted: function () {
    this.getListm(_URL.jsXxlist)
    if (window.history && window.history.pushState) {
      //往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.backChange, false); //false阻止默认事件
  },
  methods: {
    go(url,type,title){
      this.$router.push({
        path:url,
        query:{
          type:type,
          title:title
        }
      });
    },
     getListm(url){
          let that = this;
          let user =  JSON.parse(localStorage.getItem('user'))
          let obj = {
            flag:'gwyhsb',
            fzrids:user.id,
            isread:-1,
            pageNum:1,
            pageSize:1
          };
          Toast.loading({
            message: "数据加载中...",
            forbidClick: true,
            duration: 0,
          });
          getAction(url, obj).then((res) => {
            console.log(JSON.stringify(res));
            Toast.clear();
            // that.yhList = res.data;
            that.mnun =  res.data.total
          });
      },
  },
};
</script>
<style lang="less">
.view1 {
  .van-swipe-item img {
    width: 100%;
  }
  .grids{
    margin-top: -5px;
    background: white;
  }
  .dots{
      color: white;
      background: red;
      text-align: center;
      position: absolute;
      z-index: 9999;
      left:18%;
      top:10px;
      // padding:1px 6px 1px 6px;
      height:15px;
      line-height: 17px;
      width:20px;
      border-radius: 10px;
      font-size: 13px;
    }
}
</style>

